// extracted by css-extract-rspack-plugin
module.exports =  {};